import React, { useContext, OptionHTMLAttributes } from 'react';
import CoreSelectContext from '../../CoreSelectContext';

export interface OptionProps extends OptionHTMLAttributes<HTMLOptionElement> {}

function Option(props: OptionProps) {
  const value = useContext(CoreSelectContext);

  return <option aria-selected={value === props.value} {...props} />;
}

Option.displayName = 'Option';

export default Option;
